import { z } from "zod/v4";

import { createEndpointBase } from "./core";
import { ProjectSchemas } from "../ea.schema";
import { ProjectsFilterSchema } from "../ea.schema.query";

const base = "projects";
const projects = createEndpointBase(base);

export const projectsEndpoints = {
  projectsGet: projects({
    method: "GET",
    path: "",
    request: z.object({ filter: ProjectsFilterSchema.optional() }).optional(),
    response: z.array(ProjectSchemas["general"]),
    description: "Retrieves a list of projects with filtering support.",
  }),
  projectsCreate: projects({
    method: "POST",
    path: "",
    request: ProjectSchemas["createData"],
    response: z.any(),
    description: "Creates a new project.",
  }),
  projectsUpdate: projects({
    method: "PATCH",
    path: ":id",
    request: ProjectSchemas["update"],
    response: z.any(),
    description: "Updates an existing project.",
  }),
  projectsDelete: projects({
    method: "DELETE",
    path: ":id",
    request: z.any(),
    response: z.any(),
    requestType: {} as { id: number; options?: { removeTestPlan?: boolean } },
    description: "Permanently deletes a project.",
  }),
} as const;
